import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { env } from '@/env'
import { appConfig } from '@/hooks/use-appConfig'

export const AppConfigProvider = ({
	children,
}: Readonly<{ children: ReactNode }>) => {
	const [isLoaded, setIsLoaded] = useState(false)
	const { data: settings, isSuccess } = useQuery({
		queryKey: ['appConfig'],
		queryFn: async () => {
			const response = await fetch(env.VITE_CONFIG_PATH ?? `/config.json`, {
				method: 'GET',
			})
			if (!response.ok) {
				// hrow new Error('Failed to fetch tenants')
				return {}
			}
			try {
				return (await response.json()) as appConfig.ApiAppConfig
			} catch (error) {
				if (import.meta.env.DEV) {
					// biome-ignore lint/suspicious/noConsole: We want to log the JSON parsing error for debugging purposes in development.
					console.warn('Error parsing JSON:', error)
				} else {
					// biome-ignore lint/suspicious/noConsole: We want to log the JSON parsing error for debugging purposes in production.
					console.error('Error parsing JSON:', error)
				}
				return {}
			}
		},
		staleTime: Infinity,
		initialData: undefined,
		structuralSharing: true,
	})

	useEffect(() => {
		if (isSuccess) {
			appConfig.setConfig(settings)
			setIsLoaded(true)
		}
	}, [settings, isSuccess])

	if (isLoaded) {
		return <>{children}</>
	}
	return null
}
